import clsx from 'clsx'
import React from 'react'

export const SlideToggle = ({ checked, onClick, disabled, ...props }) => {
  return (
    <div className="flex items-center justify-center w-14 mr-2" onClick={onClick}>
      <label className="flex items-center">
        <div className="relative">
          <div
            className={clsx(
              'block bg-gray-500 w-14 h-8 rounded-full cursor-pointer',
              disabled && 'opacity-20 cursor-not-allowed'
            )}
          />
          <div
            className={clsx(
              'absolute top-1 w-6 h-6 rounded-full transition',
              !checked && 'left-1 bg-white',
              checked && 'right-1 bg-green-500',
              disabled && 'opacity-20 '
            )}
          />
        </div>
      </label>
    </div>
  )
}
export default SlideToggle
